<template>
  <v-form @submit.prevent ref="form" v-model="valid">
    {{ valid }}
    <service-form :doc="doc" />
    <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
    <pre>
        {{ doc }}
      </pre
    >
  </v-form>
</template>

<script>
// @ is an alias to /src
import ServiceForm from "./ServiceForm";
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserServiceFormAdd",
  components: {
    ServiceForm,
  },
  data() {
    return {
      valid: true,
      doc: {},
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.validate();
      if (this.valid) {
        let ref = fb.exServiceNotesCollection.doc();
        ref
          .set({
            createdOn: new Date(),
            id: ref.id,
            title: this.populateField(this.doc.title),
            description: this.populateField(this.doc.description),
            categories: this.populateField(this.doc.categories),
            subitems: this.populateField(this.doc.subitems),
            uid: this.currentUser.uid,
            pid: this.currentProjectModel.id,
          })
          .then(() => {
            this.$emit("complete");
          })
          .catch((error) => {
            alert("Error adding document: ", error);
          });
      }
    },
    populateField(field) {
      return field ? field : null;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
